// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1a5ME","boxTitle":"Qualiphy_boxTitle__2hyiB","box":"Qualiphy_box__1XWEv","toggleWrap":"Qualiphy_toggleWrap__exzEu"};